import { PaymentOption, VacuumOption } from "../../types/vacuum.types";
import { PAGES, PAYMENT_TYPES, TotemVacuumStoreState, VacuumStoreInteraction } from "./VacumStore.types";

export const paymentOptions: PaymentOption[] = [
  {
    type: PAYMENT_TYPES.CARD_DEBIT,
    title: "Cartão de Débito",
  },
  {
    type: PAYMENT_TYPES.CARD_CREDIT,
    title: "Cartão de Crédito",
  },
];

export const defaultVacuum = {
  deviceId: "1",
  name: "Aspirador",
  pricePerMinute: 1.00,
  station: ""
}

export const vacuumStoreInteraction: VacuumStoreInteraction = {
  currPage: PAGES.START_PAGE,
  selectedVacuum: {} as VacuumOption,
  selectedMinutes: 10,
  selectedPayment: {} as any,
  errorMsg: "",
  finalPrice: 0,
  paymentId: "",
  taxId: "",
  cieloTransactionId: "",
}

export const vacuumStoreState: TotemVacuumStoreState = {
  ...vacuumStoreInteraction,
  vacuumOptions: [],
  totemId: "",
  terminalId: "",
};